import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { HeadContent, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { ConnectBar } from '../../components/ConnectBar/ConnectBar'
import { useVerifyDiscord } from './hooks/useVerifyDiscord'

export const AppsDiscordVerification = () => {
  const { connectBarProps } = useVerifyDiscord()

  return (
    <>
      <HeadContent title="Join our Discord community" />
      <PageLayout size="tiny">
        <Dashboard.Section
          name="Join our Discord community"
          topContent={<DashboardBackButton label="Home" to={routing.home} />}
          bottomContent={
            <div style={{ lineHeight: 1.5 }}>
              <p>Connect with fellow creators and earn $5 in sample credit</p>
            </div>
          }
        >
          <div style={{ marginTop: 16 - 24, marginBottom: 40 }}>
            {connectBarProps ? (
              <ConnectBar {...connectBarProps} />
            ) : (
              <Skeleton>
                <Skeleton.Shape height={64} />
              </Skeleton>
            )}
          </div>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
